var exports = {
  "sR": "RelativeTime__EA4Bb1",
  "ge": "commitMessageWrapper__2-Ti7w",
  "df": "commitMessage__fj4I3Y",
  "I4": "reblameWrapper__fn3szf",
  "Di": "lineCodePairs__eWZ-Y7",
  "U_": "codeLine__aDEziX",
  "wD": "blameSegmentWrapper__N8xYS8",
  "VA": "blameNoLineData__xcZWgL",
  "_V": "virtualBlameWrapper__eESMn0",
  "Et": "blameForRange__ZztvUL",
  "Js": "ageIndicator__ZtYOdb",
  "QJ": "blameAgeIndicator__wn6mOs",
  "ez": "authorAvatarWrapper__GI3Txg",
  "IF": "timestampAgo__kDGIHH",
  "Wj": "timestampWrapperDesktop__yHOQh0",
  "AZ": "timestampWrapperMobile__vtxd6T",
};

module.exports = exports;
